import React, { Component } from 'react'
import PropTypes from 'prop-types'
import carrotImage from './assets/carrot.svg'
import AppleIcon from './assets/img_apple_avatar.svg'
import Item from './item'
import {
  Container,
  Carrot,
  UserName,
  UserIconWrapper,
} from './component.styles'
import { NAVIGATION_ITEMS } from './data'

export default class GlobalNavProfileDropdown extends Component {
  static propTypes = {
    show: PropTypes.bool,
  }

  render() {
    const { show, navigateLeaveApp, name } = this.props || {}
    return (
      show && (
        <Container>
          <Carrot src={carrotImage} />
          <UserName>
            <UserIconWrapper>
              <img src={AppleIcon} />
            </UserIconWrapper>
            {name}
          </UserName>
          {NAVIGATION_ITEMS.map(({ label, link }, index) => (
            <Item
              index={index}
              key={`${index}-${label}`}
              label={label}
              link={link}
              onClick={() => navigateLeaveApp(link)}
            />
          ))}
        </Container>
      )
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/GlobalNav/ProfileDropdown/component.jsx